<template>
  <Card class="challenge-container">
    <div class="text-center mb-4">
      <div class="challenge-type-badge">
        {{ challengeTypeNames[challenge.type] }}
      </div>
      <h2 class="text-xl font-semibold text-primary mt-2">
        {{ challenge.instruction }}
      </h2>
    </div>

    <!-- Guess Name Challenge -->
    <GuessNameChallenge
      v-if="challenge.type === 'guess_name'"
      :challenge="challenge"
      :feedback="feedback"
      @answer="handleAnswer"
    />

    <!-- Guess Face Challenge -->
    <GuessFaceChallenge
      v-else-if="challenge.type === 'guess_face'"
      :challenge="challenge"
      :feedback="feedback"
      @answer="handleAnswer"
    />

    <!-- Match 3 Challenge -->
    <Match3Challenge
      v-else-if="challenge.type === 'match_3'"
      :challenge="challenge"
      :feedback="feedback"
      @answer="handleAnswer"
    />
  </Card>
</template>

<script setup>
import { ref, computed } from 'vue'
import Card from '../ui/Card.vue'
import GuessNameChallenge from './GuessNameChallenge.vue'
import GuessFaceChallenge from './GuessFaceChallenge.vue'
import Match3Challenge from './Match3Challenge.vue'

const props = defineProps({
  challenge: {
    type: Object,
    required: true
  }
})

const emit = defineEmits(['answer'])

const feedback = ref(null)
const showingFeedback = ref(false)

const challengeTypeNames = {
  guess_name: 'Guess the Name',
  guess_face: 'Guess the Face',
  match_3: 'Match Three'
}

async function handleAnswer(answer) {
  if (showingFeedback.value) return

  showingFeedback.value = true
  const result = await emit('answer', answer)

  // Show feedback
  feedback.value = {
    isCorrect: result?.isCorrect || false,
    xpGained: result?.xpGained || 0,
    correctAnswer: props.challenge.correctAnswer
  }

  // Clear feedback after delay
  setTimeout(() => {
    feedback.value = null
    showingFeedback.value = false
  }, 1500)
}
</script>

<style scoped>
.challenge-container {
  @apply max-w-xl mx-auto;
}

.challenge-type-badge {
  @apply inline-block px-3 py-1 bg-secondary-fixed text-on-secondary-fixed rounded-full text-sm font-medium;
}
</style>
